<div class="spinner-wrapper">
    <mat-spinner></mat-spinner>
    <span *ngIf="showText" t7e="loading">Loading...</span>
</div>
